/**
 *
 * @module Basic plugin events enum
 * @desc Baes plugin event enumeration
 *
 */
export default {
    READY: 'pluginReady',
};
